const SkinCeuticalsComparison = {
  copy: "SkinCeuticals C E Ferulic",
  brand: "Skin Ceuticals",
  characteristics: {
    Price: {
      BP: { "en-GB": "£23.50", "en-US": "$29" },
      copy: { "en-GB": "£165", "en-US": "$182" },
    },
    "Vitamin C": {
      BP: { "en-GB": "15%", "en-US": "15%" },
      copy: { "en-GB": "15%", "en-US": "15%" },
    },
    "Ferulic Acid": {
      BP: { "en-GB": "0.50%", "en-US": "0.50%" },
      copy: { "en-GB": "0.50%", "en-US": "0.50%" },
    },
    "Tranexamic Acid": {
      BP: { "en-GB": "1%", "en-US": "1%" },
      copy: { "en-GB": "0%", "en-US": "0%" },
    },
    "Vitamin E": {
      BP: { "en-GB": "0%", "en-US": "0%" },
      copy: { "en-GB": "1%", "en-US": "1%" },
    },
  },
}

type ProductCharacteristic = {
  BP: { [locale: string]: string }
  copy: { [locale: string]: string }
}

export type ProductComparison = {
  copy: string
  brand: string
  characteristics: {
    [attribute: string]: ProductCharacteristic
  }
}

type ProductComparisonSkus = Record<string, ProductComparison>

export const ProductComparisonSkus: ProductComparisonSkus = {
  "190910": {
    copy: "Sunday Riley C.E.O. Vitamin C Brightening Rich Hydration Moisturizer",
    brand: "Sunday Riley",
    characteristics: {
      Price: {
        BP: { "en-GB": "£15", "en-US": "$18" },
        copy: { "en-GB": "£60", "en-US": "$65" },
      },
      "Vitamin C Content": {
        BP: { "en-GB": "3%", "en-US": "3%" },
        copy: { "en-GB": "5%", "en-US": "5%" },
      },
      "Ferulic Acid": {
        BP: { "en-GB": "Yes", "en-US": "Yes" },
        copy: { "en-GB": "No", "en-US": "No" },
      },
      Vegan: {
        BP: { "en-GB": "Yes", "en-US": "Yes" },
        copy: { "en-GB": "No", "en-US": "No" },
      },
    },
  },
  "1017989": {
    copy: "Dr. Barbara Sturm Face Cream",
    brand: "Dr Barbara Sturm",
    characteristics: {
      Price: {
        BP: { "en-GB": "£19", "en-US": "$25" },
        copy: { "en-GB": "£150", "en-US": "$240" },
      },
      "Anti-Aging": {
        BP: { "en-GB": "Yes", "en-US": "Yes" },
        copy: { "en-GB": "Yes", "en-US": "Yes" },
      },
      Hydrating: {
        BP: { "en-GB": "Yes", "en-US": "Yes" },
        copy: { "en-GB": "Yes", "en-US": "Yes" },
      },
      "Anti-oxidents": {
        BP: { "en-GB": "Yes", "en-US": "Yes" },
        copy: { "en-GB": "Yes", "en-US": "Yes" },
      },
    },
  },
  "198671": {
    copy: "Dr. Barbara Sturm The Better B Niacinamide Serum",
    brand: "Dr Barbara Sturm",
    characteristics: {
      Price: {
        BP: { "en-GB": "£15", "en-US": "$19" },
        copy: { "en-GB": "£125", "en-US": "$160" },
      },
      "Pore Refining": {
        BP: { "en-GB": "Yes", "en-US": "Yes" },
        copy: { "en-GB": "Yes", "en-US": "Yes" },
      },
      "Skin Brightening": {
        BP: { "en-GB": "Yes", "en-US": "Yes" },
        copy: { "en-GB": "Yes", "en-US": "Yes" },
      },
      Niacinamide: {
        BP: { "en-GB": "10%", "en-US": "10%" },
        copy: { "en-GB": "5%", "en-US": "5%" },
      },
    },
  },
  "194772": {
    copy: "Augustinus Bader The Ultimate Soothing Cream",
    brand: "Augustinus Bader",
    characteristics: {
      Price: {
        BP: { "en-GB": "£44", "en-US": "$50" },
        copy: { "en-GB": "£230", "en-US": "$290" },
      },
      Niacinamide: {
        BP: { "en-GB": "Yes", "en-US": "Yes" },
        copy: { "en-GB": "Yes", "en-US": "Yes" },
      },
      Peptides: {
        BP: { "en-GB": "Yes", "en-US": "Yes" },
        copy: { "en-GB": "Yes", "en-US": "Yes" },
      },
      "Hylauronic Acid": {
        BP: { "en-GB": "Yes", "en-US": "Yes" },
        copy: { "en-GB": "Yes", "en-US": "Yes" },
      },
    },
  },
  "72504": {
    copy: "Estee Lauder Advanced Night Repair",
    brand: "Estee Lauder",
    characteristics: {
      Price: {
        BP: { "en-GB": "£44", "en-US": "$49" },
        copy: { "en-GB": "£115", "en-US": "$125" },
      },
      Smoothing: {
        BP: { "en-GB": "Yes", "en-US": "Yes" },
        copy: { "en-GB": "Yes", "en-US": "Yes" },
      },
      "Skin Firming": {
        BP: { "en-GB": "Yes", "en-US": "Yes" },
        copy: { "en-GB": "Yes", "en-US": "Yes" },
      },
      "Brightening & Renewing": {
        BP: { "en-GB": "Yes", "en-US": "Yes" },
        copy: { "en-GB": "Yes", "en-US": "Yes" },
      },
      "Petroleum based ingredients (PEGs)": {
        BP: { "en-GB": "No", "en-US": "No" },
        copy: { "en-GB": "Yes", "en-US": "Yes" },
      },
      Vegan: {
        BP: { "en-GB": "Yes", "en-US": "Yes" },
        copy: { "en-GB": "No", "en-US": "No" },
      },
    },
  },
  "968975": {
    copy: "REN Perfect Canvas Clean Jelly Oil Cleanser",
    brand: "REN",
    characteristics: {
      Price: {
        BP: { "en-GB": "£10", "en-US": "$14" },
        copy: { "en-GB": "£29", "en-US": "$37" },
      },
      Hydrating: {
        BP: { "en-GB": "Yes", "en-US": "Yes" },
        copy: { "en-GB": "Yes", "en-US": "Yes" },
      },
      "Skin Soothing": {
        BP: { "en-GB": "Yes", "en-US": "Yes" },
        copy: { "en-GB": "Yes", "en-US": "Yes" },
      },
      "Vitamin E": {
        BP: { "en-GB": "Yes", "en-US": "Yes" },
        copy: { "en-GB": "Yes", "en-US": "Yes" },
      },
    },
  },
  "190705": {
    copy: "Dr Barbara Sturm Lifting Serum",
    brand: "Dr Barbara Sturm",
    characteristics: {
      Price: {
        BP: { "en-GB": "£14", "en-US": "$19" },
        copy: { "en-GB": "£85", "en-US": "$110" },
      },
      "Anti-Aging": {
        BP: { "en-GB": "Yes", "en-US": "Yes" },
        copy: { "en-GB": "Yes", "en-US": "Yes" },
      },
      Hydrating: {
        BP: { "en-GB": "Yes", "en-US": "Yes" },
        copy: { "en-GB": "Yes", "en-US": "Yes" },
      },
      Firming: {
        BP: { "en-GB": "Yes", "en-US": "Yes" },
        copy: { "en-GB": "Yes", "en-US": "Yes" },
      },
    },
  },
  "191368": {
    copy: "Paula's Choice Clinical 0.3% retinol + 2% bakuchiol treatment",
    brand: "Paula's Choice",
    characteristics: {
      Price: {
        BP: { "en-GB": "£15", "en-US": "$29" },
        copy: { "en-GB": "£59", "en-US": "$64" },
      },
      Retinol: {
        BP: { "en-GB": "Yes", "en-US": "Yes" },
        copy: { "en-GB": "Yes", "en-US": "Yes" },
      },
      "Ceramide Blend": {
        BP: { "en-GB": "Yes", "en-US": "Yes" },
        copy: { "en-GB": "Yes", "en-US": "Yes" },
      },
      "Lactic Acid": {
        BP: { "en-GB": "Yes", "en-US": "Yes" },
        copy: { "en-GB": "No", "en-US": "No" },
      },
    },
  },
  "1019648": SkinCeuticalsComparison,
  "77110": SkinCeuticalsComparison,
}
